/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface WorkProgressDto
 */
export interface WorkProgressDto {
    /**
     * 
     * @type {number}
     * @memberof WorkProgressDto
     */
    openSteps?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkProgressDto
     */
    skippedSteps?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkProgressDto
     */
    withoutEvaluation?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkProgressDto
     */
    passedSteps?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkProgressDto
     */
    warningSteps?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkProgressDto
     */
    failedSteps?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkProgressDto
     */
    $type?: WorkProgressDtoTypeEnum;
}


/**
 * @export
 */
export const WorkProgressDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoWorkProgressDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.WorkProgressDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type WorkProgressDtoTypeEnum = typeof WorkProgressDtoTypeEnum[keyof typeof WorkProgressDtoTypeEnum];


/**
 * Check if a given object implements the WorkProgressDto interface.
 */
export function instanceOfWorkProgressDto(value?: unknown): value is WorkProgressDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(WorkProgressDtoTypeEnum)[0];
}

export function WorkProgressDtoFromJSON(json: any): WorkProgressDto {
    return WorkProgressDtoFromJSONTyped(json, false);
}

export function WorkProgressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkProgressDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'openSteps': !exists(json, 'openSteps') ? undefined : json['openSteps'],
        'skippedSteps': !exists(json, 'skippedSteps') ? undefined : json['skippedSteps'],
        'withoutEvaluation': !exists(json, 'withoutEvaluation') ? undefined : json['withoutEvaluation'],
        'passedSteps': !exists(json, 'passedSteps') ? undefined : json['passedSteps'],
        'warningSteps': !exists(json, 'warningSteps') ? undefined : json['warningSteps'],
        'failedSteps': !exists(json, 'failedSteps') ? undefined : json['failedSteps'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function WorkProgressDtoToJSON(value?: WorkProgressDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'openSteps': value.openSteps,
        'skippedSteps': value.skippedSteps,
        'withoutEvaluation': value.withoutEvaluation,
        'passedSteps': value.passedSteps,
        'warningSteps': value.warningSteps,
        'failedSteps': value.failedSteps,
        '$type': value.$type,
    });
}

